export default __webpack_public_path__ + "static/media/graphic-22.1312a597.png";